import paths from '../../shared/route/paths'
import TodayTaskPage from './TodayTask.page'

export const TodayTaskModule = {
  isPrivate: false,
  routers: {
    path: paths.TODAY_TASK,
    component: TodayTaskPage,
  },
}
